import { Button, InlineError, Input, Spinner, Switch } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import UploadImage from 'components/commons/upload-image'

export const VideoSection = ({ data, onChangeForm, errorForm, isLoadingUpload, isLoading, isUpdating, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-6 pb-[280px] overflow-auto'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center justify-between border border-neutral-20 px-6 py-4 rounded-lg'}>
                        <p className={'font-semibold text-lg text-black-95'}>{'Video'}</p>
                        <div className={'flex items-center space-x-6'}>
                            <p className={'font-semibold'}>{data?.is_show ? 'Show' : 'Hide'}</p>
                            <Switch
                                name={'is_show'}
                                checked={data?.is_show}
                                onChange={(e) => onChangeForm({ ...e, value: e.checked })}
                            />
                        </div>
                    </div>
                    <TabToggle
                        title={'Video'}
                        content={
                            <div className={'flex flex-col space-y-16'}>
                                <div className={'flex space-x-16'}>
                                    <div className={`flex-1 flex-col space-y-3`}>
                                        <div className={'font-semibold text-blue-90 required'}>
                                            Background Video Desktop (1366px x 1076px)
                                        </div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={`background-desktop`}
                                            value={data?.desktop_background?.base64 || data?.desktop_background}
                                            onChange={(value) => onChangeForm({ name: 'desktop_background', value })}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.desktop_background} />
                                    </div>
                                    <div className={`flex-1 flex-col space-y-3`}>
                                        <div className={'font-semibold text-blue-90 required'}>
                                            Background Video Mobile (414px x 909px)
                                        </div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={`background-mobile`}
                                            value={data?.mobile_background?.base64 || data?.mobile_background}
                                            onChange={(value) => onChangeForm({ name: 'mobile_background', value })}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.mobile_background} />
                                    </div>
                                </div>
                                <div className={'flex space-x-16'}>
                                    <div
                                        className={`flex-1 flex-col ${(data?.title_image_url?.base64 || data?.title_image_url) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90 required'}>Image Title</div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={'image-title'}
                                            value={data?.title_image_url?.base64 || data?.title_image_url}
                                            onChange={(value) => onChangeForm({ name: 'title_image_url', value })}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.title_image_url} />
                                    </div>
                                    <div className={'flex-1 flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Description</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'description'}
                                            placeholder={'Masukkan description'}
                                            type={'text-area'}
                                            rows={5}
                                            value={data?.description}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.description} />
                                    </div>
                                </div>

                                <div className={'flex w-1/2 flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90 required'}>Video URL</div>
                                    <Input
                                        className={'flex-1'}
                                        name={'video_url'}
                                        placeholder={'Masukkan link video'}
                                        value={data?.video_url}
                                        onChange={onChangeForm}
                                    />
                                    <div className={'font-semibold text-blue-90 text-xs whitespace-nowrap'}>{`Contoh URL:\n https://www.youtube-nocookie.com/embed/{VIDEO_ID}`}</div>
                                    <InlineError className='mt-2' message={errorForm?.video_url} />
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex justify-end w-[calc(100%-544px)] py-3 bg-white fixed bottom-0 right-9 z-20'}>
                        <Button
                            className={'w-[200px] !bg-gradient-to-r !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                            loading={isLoadingUpload || isUpdating}
                            title={'SAVE ALL CHANGES'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
